import React, { useMemo } from 'react';
import { Typography, InfoRow, Checkbox, Select } from '../../../../../../../../components';
import { OPTIMIZATION_TYPES, MODERNIZATION_OPTIONS } from '../../../constants';

import './OSSettings.scss';

const { Title, Paragraph } = Typography;

export const OSSettings = ({ ignoredOptimizations, setIgnoredOptimizations, record, isLoading }) => {
    const modernizationIgnored = ignoredOptimizations?.modernization;

    const isIgnoreRecommendationsChecked = useMemo(
        () =>
            modernizationIgnored.includes(OPTIMIZATION_TYPES.OSM) &&
            modernizationIgnored.includes(OPTIMIZATION_TYPES.SQLM),
        [ignoredOptimizations],
    );

    const handleIgnoreRecommendations = (e) => {
        const isChecked = e.target.checked;
        // Update optimizations state, or if unchecked, reset to record's ignored optimizations
        setIgnoredOptimizations((prev) => ({
            ...prev,
            modernization: isChecked
                ? [...new Set([...prev.modernization, OPTIMIZATION_TYPES.OSM, OPTIMIZATION_TYPES.SQLM])]
                : prev.modernization.filter((opt) => !MODERNIZATION_OPTIONS.includes(opt)),
        }));
    };

    return (
        <div className="os-settings">
            <div className="settings-subsection">
                <Title level={5}>Current OS</Title>
                <InfoRow label="Reported OS" value={record?.reported_os_version || ''} tooltipThreshold={30} />
                <InfoRow label="Configured OS" value={record?.configured_os_version || ''} tooltipThreshold={30} />
            </div>
            <div className="settings-subsection">
                <Checkbox
                    checked={isIgnoreRecommendationsChecked}
                    onChange={handleIgnoreRecommendations}
                    disabled={isLoading}
                >
                    Ignore Recommendations
                </Checkbox>
                {/* <Paragraph className="recommendations-text">Recommendations based on usage or below settings.</Paragraph> */}
                {!isIgnoreRecommendationsChecked && (
                    <Paragraph className="recommendations-text">OS upgrades will be configured in Migration.</Paragraph>
                )}
            </div>
            {/* Hidden until we have the relevant information */}
            {/* <div className="settings-subsection">
                <Title level={5}>Recommended OS Upgrade</Title>
                <Select
                    className="os-select"
                    placeholder="Select OS Version"
                    options={[{ value: 'windows-server-2025', label: 'Windows Server 2025' }]}
                />
            </div> */}
        </div>
    );
};
